import { AssetTypes } from "@zapier/utils";
import { trpc } from "../trpc";

export interface FetchConnectedAssetsInput {
  id: string;
}

export const useFetchConnectedAssets = ({ id }: FetchConnectedAssetsInput) => {
  const { data, isLoading, isFetching } =
    trpc.interface.getConnectedAssets.useQuery(
      { id },
      {
        enabled: !!id,
      },
    );

  return {
    connectedAssets:
      data?.map((asset) => ({
        id: asset.assetId,
        title: asset.name,
        type: asset.assetType as AssetTypes,
      })) || [],
    isLoading,
    isFetching,
  };
};
